import React, { Component } from "react";
import { StripeProvider } from "react-stripe-elements";
import Script from "react-load-script";
import styled from "styled-components";
import { Text } from "rebass";

import config from "../../utils/config";
// import ErrorBanner from "../ui/Banner/ErrorBanner";

type Props = {
  render: React.Node
};

const { Fragment } = React;

class Stripe extends Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      stripeLoaded: false
    };
  }

  handleScriptCreate = () => {
    this.setState({
      stripeLoaded: false
    });
  };

  handleScriptError = () => {
    this.setState({
      stripeError: true
    });
  };

  handleScriptLoad = () => {
    this.setState({
      stripeLoaded: true
    });
  };

  rerender = () => {
    this.setState({
      stripeLoaded: false,
      stripeError: false
    });

    window.location.reload();
  };

  render() {
    const { stripeLoaded, stripeError } = this.state;

    return (
      <Fragment>
        <Script
          url="https://js.stripe.com/v3/"
          onCreate={this.handleScriptCreate}
          onError={this.handleScriptError}
          onLoad={this.handleScriptLoad}
        />

        {stripeError && (
          <ErrorText m={[2, 2, "16px"]} mb={[3]} p={[3]} f={[1]}>
            It looks like there&apos;s been an error, hence the big red box.
            Please <button onClick={this.rerender}>click here</button> to
            reload.
          </ErrorText>
        )}

        {!stripeLoaded &&
          !stripeError && (
            <StyledText py={["50px"]} f={[2]} className="loading">
              Loading
            </StyledText>
          )}

        {stripeLoaded &&
          !stripeError && (
            <StripeProvider apiKey={config.stripe.key}>
              {this.props.render}
            </StripeProvider>
          )}
      </Fragment>
    );
  }
}

export default Stripe;

// Styled Components
const StyledText = styled(Text)`
  text-align: center;
`;

const ErrorText = styled(Text)`
  background: ${p => p.theme.colors.error};
  border-radius: 5px;
  color: #fff;

  a {
    color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Stripe/Stripe.jsx